module.exports = "<div id=\"containerMain\">\n  <app-main-icon></app-main-icon>\n  <app-nav-bar></app-nav-bar>\n  <router-outlet>    </router-outlet>\n</div>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 398
// module chunks = 1